import { useCallback } from 'react';

import { RequestResult } from '@api/responseModels/requestResult';
import { ScheduleTemplateListResp } from '@api/responseModels/worker/schedule/scheduleTemplateListResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { TState } from '../schedule';

export function useLoadTemplates({
    state,
    crmID,
    messageApi,
}: {
    state: TState;
    crmID: number | string;
    messageApi: any;
}) {
    const loadTemplates = useCallback(
        async (page = 1) => {
            state.isLoading = true;
            try {
                const result: RequestResult<ScheduleTemplateListResp> = await CRMAPIManager.request(
                    async (api) => {
                        return await api.getScheduleTemplateList(+crmID, page);
                    }
                );

                if (result.errorCode) throw result;

                state.scheduleTemplates = [...state.scheduleTemplates, ...result.data.data];
                state.templatesMeta = result.data.meta;
            } catch (err) {
                messageApi.error('Ошибка при загрузке шаблонов');
                console.error(err);
            } finally {
                state.isLoading = false;
            }
        },
        [crmID, messageApi, state]
    );

    return { loadTemplates };
}
